import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { MarketingModule } from './marketing.module';
platformBrowserDynamic().bootstrapModule(MarketingModule);
